import requests from "./httpService";

const ApkWaiterServices = {

  getApkWaiterList: async () => {
    return requests.get("/appWaiter"); 
  }
};

export default ApkWaiterServices;